import { Add } from "@mui/icons-material";
import { Box, Button, Typography } from "@mui/material";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { useCallback, useEffect, useMemo, useState } from "react";
import { Product } from "../../Models/ProductModel.ts";
import { PRODUCT_TYPES_CASES } from "../../Models/StateConstants.ts";
import { getProductList } from "../../Requests/ProductServece.ts";
import { useFilteredBySearch } from "../../Hooks/useFilteredBySearch";
import TableToolbarWithSearch from "../TableToolbar/TableToolbarWithSearch.jsx";
import ColumnsIcon from "../TableToolbar/ColumnsIcon.jsx";


const SEARCH_FIELD_OPTIONS = [
  { value: 'productName', label: 'Product Name' },
]

const COLUMNS = [
  {
    accessorKey: 'productName',
    header: 'Product Name'
  },
  {
    accessorKey: 'metadata.type',
    header: 'Type',
    enableGlobalFilter: false,
    filterVariant: 'select',
    filterSelectOptions: PRODUCT_TYPES_CASES.map((value) => value.label)
  }
]


export default function ProductListView() {

  const [isLoading, setIsloading] = useState<boolean>(true)
  const isRefetching = false
  const [tableData, setTableData] = useState<Product[]>([])
  const [globalFilter, setGlobalFilter] = useState<string | undefined>(undefined)
  const [searchField, setSearchField] = useState<string>(SEARCH_FIELD_OPTIONS[0].value)

  const columns = useMemo(() => COLUMNS, [])

  const getRowSearchValue = useMemo(
    () => (row: Product, field: string) =>
      (row as unknown as Record<string, unknown>)[field],
    []
  )
  const data = useFilteredBySearch(tableData, globalFilter, searchField, getRowSearchValue)

  const fetchData = useCallback(async (): Promise<void> => {
    const result = await getProductList()
    setIsloading(false)
    setTableData(result)
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  const table = useMaterialReactTable({
    columns,
    data,
    enableDensityToggle: false,
    enableFullScreenToggle: false,
    state: {
      isLoading: isLoading,
      showProgressBars: isRefetching,
      pagination: { pageIndex: 0, pageSize: 100 }
    },
    icons: {
      ViewColumnIcon: ColumnsIcon,
    },
    onGlobalFilterChange: setGlobalFilter,
    renderTopToolbar: ({ table }) => (
      <TableToolbarWithSearch
        table={table}
        exportFileName="products"
        searchFieldOptions={SEARCH_FIELD_OPTIONS}
        searchField={searchField}
        onSearchFieldChange={setSearchField}
        globalFilter={globalFilter}
        onGlobalFilterChange={setGlobalFilter}
        selectMinWidth={160}
        action={
          <Button
            variant="contained"
            size="large"
            onClick={() => { }}
          >
            <Add />
            Add Product
          </Button>
        }
      />
    ),
    muiTableContainerProps: {
      sx: {
        maxHeight: 'calc(100vh - 300px)',
        overflow: 'auto'
      }
    }
  })

  return (
    <>
      <Box
        display="flex"
        justifyContent="space-between"
        paddingTop={2}
        paddingBottom={1}
      >
        <Typography
          variant="h4"
        >
          Products
        </Typography>
      </Box>

      <MaterialReactTable
        table={table}
      />
    </>
  )
}
